import * as consts from './MenuConsts';

const initialState = {
    menuOpened: false,
    menuScrollable: false,
    buttonsParams: {
        visibility: {
            galleryBtnVisible: false,
            threeDModelBtnVisible: false,
            floorplanBtnVisible: false,
            matterportBtnVisible: false,
            videoBtnVisible: false,
            mapBtnVisible: false,
            infoBtnVisible: false,
            shareBtnVisible: false,
            walkthruBtnVisibility: false,
            claimHomeBtnVisibility: false
        },
        titles: {
            matterportBtnTitle: '',
            threeDModelBtnTitle: ''
        },
        links: {
            claimBtnLink: ''
        },
        defaultButton: ''
    }
};

const menu = (state = initialState, action) => {
    switch (action.type) {
        case consts.MENU_BTN_CLICK:
            return {
                ...state,
                menuOpened: action.payload
            }
        case consts.MENU_RESIZE:
            return {
                ...state,
                menuScrollable: action.payload
            }
        default:
            return state
    }
}

export default menu;
